export default __webpack_public_path__ + "static/media/sms.19f28a97.svg";